import useBindingOnDataChangeEventReceiver from './useBindingOnDataChange'
import useDialog from './useDialog'
import useInit from './useInit'
import useOnReferenceSelected from './useOnReferenceSelected'
import useRedo from './useRedo'
import useUndo from './useUndo'
import useUpdateRibbon from './useUpdateRibbon'
import useDeleteReference from './useDeleteReference'
import useDeleteAllReferences from './useDeleteAllReferences'
import useShowDuplicatePopup from './useShowDuplicatePopup'
import { useAppDispatch } from '../dispatch'
import { TextcutRectangle } from '../types'
import { useLayoutContext } from '../context/LayoutContext'
import useAppNavigation from './useNavigation'

type Props = {
  dispatch: ReturnType<typeof useAppDispatch>
  storeDispatch: ReturnType<typeof useLayoutContext>['dispatch']
  references: TextcutRectangle[]
}

const useAppInitializer = ({ dispatch, references, storeDispatch }: Props) => {
  /**onSelection hooks */
  // useOnSelectionChange()
  /**end of onSelection hooks */

  useOnReferenceSelected()
  // useOnChanged()
  // useOnChangedReceiver({ setProcessing })
  useBindingOnDataChangeEventReceiver()

  //   useOnActivated()
  //   useOnActivatedReceiver()
  useUndo()
  useRedo()

  useUpdateRibbon() // manifest backward compatibility

  useDialog(dispatch)

  useInit(dispatch, storeDispatch)

  useAppNavigation()

  useDeleteReference(dispatch, references)

  useDeleteAllReferences(dispatch)

  useShowDuplicatePopup(references, storeDispatch)
}

export default useAppInitializer
